import { render, staticRenderFns } from "./RoundedRectangleSvg.vue?vue&type=template&id=4c834f26&"
import script from "./RoundedRectangleSvg.vue?vue&type=script&lang=ts&"
export * from "./RoundedRectangleSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports